import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    root: 'space-y-2',
    title: 'title-4',
    ul: 'space-y-2'
  },
  presets: {
    red: 'c-brand-2',
    green: 'c-green-30',
  },
  variant: 'quiet'
} satisfies CMSConfig['megaMenuL2Desktop']
